import { Modal, Select } from 'antd'
import React from 'react'

const SubscriptionExpireModal = ({openModal, openSubscriptionModal}) => {
  return (
    <Modal
      title="Subscription Expired"
      onCancel={() => {}}
      open={openModal}
      footer={false}
    >
      <h1 className='my-10'>
        Your Subscription has expired, kindly click the link below to update your subscription
      </h1>
      <button onClick={() => openSubscriptionModal(true)} className='px-3 py-1.5 rounded-md bg-dark_blue text-xs font-medium text-white'>Subscribe</button>
    </Modal>
  )
}

export default SubscriptionExpireModal